export const API_BASE_URL = process.env.REACT_APP_PW25_SERVER_URL;
export const USER_ROLE = 'user_role';
export const PARTNER_ID = 'partner_id';
export const PARENT_ID = 'parent_id';
export const MANAGING_PARTNER_CHILDS = 'managing_partner_childs';
export const DATE_FORMAT = 'MM/DD/YYYY';

export const ROLE_TYPES = {
  admin: 'admin',
  slh_manager: 'slh_manager',
  client: 'client',
};

export const ACCESS_TOKEN_NAME = {
  admin: 'admin_auth_token',
  slh_manager: 'manager_auth_token',
  client: 'client_auth_token',
};

export const GENDER = {
  M: 'Male',
  F: 'Female',
  O: 'Other',
};

export const CLIENT_STATUS = {
  in_progress: 'in_progress',
  failed: 'relapse',
  completed: 'completed',
  not_started: 'not_started',
};

export const INVOICE_STATUS = {
  ready: 'Ready',
  pending: 'Pending',
  submitted: 'Submitted',
  paid: 'Paid',
};

export const PF25_ADMIN_STATUS = {
  active: 'active',
  inactive: 'inactive',
  pending: 'pending',
};

export const SLH_TYPES = {
  parent: 'parent',
  child: 'child',
  no_relationship: 'no_relationship',
};
